import useGetQBRemainTags, { QBTag, QBTagCategory } from './useGetQBRemainTags';

export default useGetQBRemainTags;
export { QBTagCategory };
export type { QBTag };
